var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 24,
    viewBox: "0 0 38 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 37,
    height: 23,
    rx: 3.5,
    fill: "white",
    stroke: "#E3E6ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2845 6.49658H16.3853V17.0965H22.2845V6.49658Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.76 11.7963C16.76 9.73624 17.7151 7.76982 19.3257 6.49633C16.4041 4.19281 12.1529 4.69846 9.8494 7.63873C7.56461 10.5603 8.07026 14.7928 11.0105 17.0963C13.4639 19.0252 16.8911 19.0252 19.3444 17.0963C17.7151 15.8228 16.76 13.8564 16.76 11.7963Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2438 11.7963C30.2438 15.5231 27.2286 18.5383 23.5018 18.5383C21.9849 18.5383 20.5241 18.0327 19.3442 17.0963C22.2658 14.7928 22.7714 10.5603 20.4679 7.62C20.1308 7.20799 19.7562 6.81471 19.3442 6.49633C22.2658 4.19281 26.517 4.69846 28.8018 7.63873C29.7382 8.81858 30.2438 10.2794 30.2438 11.7963Z",
    fill: "#F79E1B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/Mastercard.ea91d45b923bdfc59ca33c26c2ecb99c.svg";
export { ForwardRef as ReactComponent };